import cartActionTypes from './cartTypes'
import {addItemToCart} from './cart.utils'
import {removeItemFromCart , EmptyCartItems} from './cart.utils'
const INITIAL_STATE = {
    hidden:true,
    cartItems:[]
};

const cartReducer = (state=INITIAL_STATE , action)=>{
    switch(action.type){
        case cartActionTypes.TOGGLE_CART_HIDDEN:
            return{
                ...state,
                hidden:!state.hidden
            }
        case cartActionTypes.ADD_ITEMS:
            return{
                ...state,
                cartItems: addItemToCart(state.cartItems , action.payload)
            }
        case cartActionTypes.CLEAR_ITEM_FROM_CART:
            return{
                ...state ,
                cartItems : state.cartItems.filter(cartItem => cartItem.id != action.payload.id)
            }
        case cartActionTypes.REMOVE_ITEM:
            return{
                ...state ,
                cartItems:removeItemFromCart(state.cartItems , action.payload) 
            }
        // case cartActionTypes.EMPTY_CART:
        //     console.log("empty-------------- called")
        //     return {
        //         ...state,
        //         cartItems:EmptyCartItems(state.cartItems )
        //     };
        default: 
            return state;
    }
}
export default cartReducer